import { Box, styled } from '@mui/material';

export const Wrapper = styled('div')({
  width: '100%',
  height: '100%',
  overflow: 'auto',
  position: 'relative',
  backgroundColor: 'transparent',
});

export const ContentDiv = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isVisible',
})<{ isVisible: boolean }>(({ isVisible, theme }) => ({
  width: '100%',
  display: isVisible ? 'block' : 'none',
  backgroundColor: 'transparent',
  padding: '16px 0',
  '& section': {
    boxShadow: theme.shadows[8],
    backgroundColor: theme.palette.common.white,
    margin: '0 auto !important',
  },
  '& .docx-wrapper': {
    background: 'transparent !important',
    padding: '0 !important',
  },
}));

export const LoaderBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  width: '100%',
  position: 'absolute',
  top: 0,
  left: 0,
  color: '#fff',
});
